export const makeLessonNodeId = (
  parentNodeId: string | null,
  sourceUid: string,
  occurrenceIndex: number,
) => {
  return `${parentNodeId ?? "root"}__${sourceUid}__${occurrenceIndex}`;
};
